module.exports = (s) => {
  return {
    name: {
      label: '名称',
      type: 'input',
      value: '',
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入名称',
      },
    },
    sort: {
      label: '排序',
      type: 'input-number',
      props: {
        min: 0,
      },
      value: 0,
      rules: {
        required: true,
        trigger: ['change'],
        message: '请输入排序',
      },
    },
    api_url: {
      label: '路由',
      type: 'input',
      value: '',
    },
    parent_id: {
      label: '父级',
      type: 'cascader',
      options: [],
      value: 0,
      props: {
        props: {
          checkStrictly: true,
          emitPath: false,
          label: 'name',
          value: 'id',
        },
      },
      on: {
        change: (val) => {
          s?.onParentIdChange(val);
        },
      },
    },
  };
};
